import { setMoving } from '../State/moving';

export default () => async (dispatch) => {

  dispatch(setMoving(true))

  setTimeout(()=> dispatch(setMoving(false)), 2000)
}